export default __webpack_public_path__ + "media/images/icons/new-instagram-481eab222541844c2b1409ffb544db13.svg";